import dynamic from "next/dynamic";

export const ServicesNonSlider = dynamic(() => import("./component"));
